import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const NotificationLikeAddFriend = ({
  notifications: initialNotifications,
  onClose,
  onMarkAsRead,
  onDelete,
  onAcceptFriendRequest, // Thêm prop onAcceptFriendRequest
}) => {
  const { setNotifications, setUnreadNotificationCount } = useAuth();
  const navigate = useNavigate();
  const [notifications, setLocalNotifications] = useState(initialNotifications || []);

  useEffect(() => {
    setLocalNotifications(initialNotifications || []);
  }, [initialNotifications]);

  const getNotificationType = (message) => {
    if (message.includes("thích bạn")) return "like";
    if (message.includes("kết bạn")) return "add_friend";
    if (message.includes("Sự kiện mới") || message.includes("được thêm vào sự kiện")) return "event_invite";
    return "other";
  };

  return (
    <div
      className="absolute right-0 mt-2 w-72 bg-white rounded-md shadow-xl py-2 border border-gray-100 animate-fade-in"
      style={{ zIndex: 1000 }}
    >
      <h4 className="px-4 py-2 text-sm font-semibold text-gray-700 border-b">Thông báo</h4>
      {notifications && notifications.length > 0 ? (
        <div className="max-h-64 overflow-y-auto">
          {notifications.map((notification) => {
            const type = getNotificationType(notification.message);
            return (
              <div
                key={notification._id || `${notification.message}-${notification.createdAt}`}
                className={`px-4 py-2 text-sm text-gray-700 hover:bg-green-50 transition duration-200 ${
                  !notification.read ? "font-semibold bg-gray-50" : ""
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p>{notification.message}</p>
                    <p className="text-xs text-gray-500">
                      {new Date(notification.createdAt).toLocaleString("vi-VN")}
                    </p>
                  </div>
                  <div className="flex flex-col space-y-1">
                    {!notification.read && (
                      <button
                        onClick={() => {
                          onMarkAsRead(notification._id);
                          setNotifications((prev) =>
                            prev.map((n) => (n._id === notification._id ? { ...n, read: true } : n))
                          );
                          setUnreadNotificationCount((prev) => prev - 1);
                        }}
                        className="px-2 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition duration-200"
                      >
                        Đã đọc
                      </button>
                    )}
                    <button
                      onClick={() => {
                        onDelete(notification._id);
                        setNotifications((prev) => prev.filter((n) => n._id !== notification._id));
                        setUnreadNotificationCount((prev) => {
                          const deletedNotification = notifications.find((n) => n._id === notification._id);
                          return deletedNotification && !deletedNotification.read ? prev - 1 : prev;
                        });
                      }}
                      className="px-2 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600 transition duration-200"
                    >
                      Xóa
                    </button>
                  </div>
                </div>
                {type === "add_friend" && notification.requestId && !notification.read && (
                  <button
                    onClick={() => onAcceptFriendRequest(notification.requestId)}
                    className="mt-1 w-full text-xs bg-green-500 text-white py-1 rounded hover:bg-green-600 transition duration-200"
                  >
                    Chấp nhận
                  </button>
                )}
                {type === "event_invite" && notification.eventId && (
                  <button
                    onClick={() => navigate(`/event/${notification.eventId}`)}
                    className="mt-1 w-full text-xs bg-purple-500 text-white py-1 rounded hover:bg-purple-600 transition duration-200"
                  >
                    Xem sự kiện
                  </button>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <p className="px-4 py-2 text-sm text-gray-500">Không có thông báo nào.</p>
      )}
      <button
        onClick={onClose}
        className="w-full text-center px-4 py-2 text-sm text-red-600 hover:bg-green-50 hover:text-red-700 transition duration-200"
      >
        Đóng
      </button>
    </div>
  );
};

export default NotificationLikeAddFriend;